<template>
  <!-- 申报书查看，仅供管理员查询 -->
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item> 申报书管理 </el-breadcrumb-item>
      <el-breadcrumb-item>申报书查看</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 搜索框 新增按钮-->
      <el-row class="row-search">
        <el-col class="el-col-user-add">
          <el-input class="user-search" clearable placeholder="请输申报书信息（用空格分隔），支持模糊搜索" v-model="query"
            style="width: 500px">
            <el-button slot="append" icon="el-icon-search" @click.prevent="queryProjectInfo()"></el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-col class="el-col-addForm" style="margin-top: 20px;">
        <span> 课题类别：</span>
        <el-select v-model="editForm.category" @change="changeCategory" filterable allow-create default-first-option
          placeholder="请选择课题类别">
          <el-option v-for="item in projectCategorys" :key="item.name" :label="item.name" :value="item.name">
          </el-option>
        </el-select>

        <span> 课题方向：</span>
        <el-select v-model="editForm.category_direction" @change="changeDirection" filterable allow-create
          default-first-option placeholder="请选择课题类别方向">
          <el-option v-for="item in projectDirections" :key="item.name" :label="item.name" :value="item.name">
          </el-option>
        </el-select>
        <el-button type="success" @click="projectInfoViewToExcel" style="margin-left: 10px;">生成excel并下载</el-button>
      </el-col>

      <!-- 申报书列表 -->
      <el-table :data="projectInfo" style="width: 100%">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="organization" label="申报单位" width="120">
        </el-table-column>
        <el-table-column prop="leader_name" label="申报人" width="120">
        </el-table-column>
        <el-table-column prop="budget" label="申报经费（万元）" width="140">
        </el-table-column>
        <el-table-column prop="tel" label="联系电话" width="120">
        </el-table-column>
        <el-table-column prop="email" label="邮箱" width="120">
        </el-table-column>
        <el-table-column prop="name" label="名称" width="280"></el-table-column>
        <el-table-column prop="category" label="课题方向" width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.category_direction }}</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="120">
          <template slot-scope="scope">{{
            scope.row.create_time | fmtdate
          }}</template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="scope">
            <div>{{ statusName(scope.row.status) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
              @click="showInfoForm(scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 申报书查看 -->
    <el-card v-show="infoFormVisible" id="id-el-card-info">
      <div style="margin-bottom: 20px">
        <!-- <el-button type="success" plain @click.prevent="ButtonShowPng()">查看图片</el-button>
        <el-button type="success" plain @click.prevent="ButtonDownOriginFile()">下载原文件</el-button> -->
      </div>
      <el-row>
        <el-col :span="24">
          <div class="header-edit">申报书详情</div>
        </el-col>
      </el-row>
      <el-card>
        <el-col class="el-col-addForm">
          <span> 课题方向：</span>
          <span>{{ editForm.category_direction }}</span>
          <span> 课题名称：</span>
          <el-input :disabled="true" v-model="editForm.name"></el-input>
        </el-col>
      </el-card>
      <el-card>
        <!-- 文件列表 -->
        <h3>课题相关文件</h3>
        <div class="div-file">
          <el-table :data="fileList" style="width: 551px" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                  @click="getPdfCode(scope.row)"></el-button>
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                  @click="downloadFile(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <h3>计划任务书</h3>
        <div class="div-file">
          <el-table :data="fileListSignAgreement" style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                  @click="getFileCode(scope.row)"></el-button>
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                  @click="downloadFile(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <h3>测试数据与分析报告</h3>
        <div class="div-file">
          <el-table :data="fileListTestData" style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                  @click="getFileCode(scope.row)"></el-button>
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                  @click="downloadFile(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <h3>中期成果报告</h3>
        <div class="div-file">
          <el-table :data="fileListMiddleCheck" style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                  @click="getFileCode(scope.row)">
                </el-button>
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                  @click="downloadFile(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <h3>结题验收材料</h3>
        <div class="div-file">
          <el-table :data="fileListFinalCheck" style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                  @click="getFileCode(scope.row)">
                </el-button>
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                  @click="downloadFile(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </el-card>
      <!-- 项目主持人情况 -->
      <el-card class="el-card-leader">
        <div class="div-leader">
          <span>项目主持人情况</span>
        </div>
        <el-table :data="projectLeader" border style="width: 1021px" :header-cell-style="{ background: '#fafafa' }">
          <el-table-column prop="username" label="姓名" width="80"></el-table-column>
          <el-table-column prop="gender" label="性别" width="60"></el-table-column>
          <el-table-column prop="national" label="民族" width="80"></el-table-column>
          <el-table-column prop="birth" label="出生年月" width="80"></el-table-column>
          <el-table-column prop="duty" label="行政职务" width="120"></el-table-column>
          <el-table-column prop="title" label="专业职称" width="120"></el-table-column>
          <el-table-column prop="major" label="研究专长" width="140"></el-table-column>
          <el-table-column prop="education" label="最后学历" width="80"></el-table-column>
          <el-table-column prop="degree" label="最后学位" width="80"></el-table-column>
          <el-table-column prop="province" label="所在省(自治区、直辖市)" width="180"></el-table-column>
        </el-table>
        <el-table :data="projectLeader" border style="width: 1021px; margin-top: -1px"
          :header-cell-style="{ background: '#fafafa' }">
          <el-table-column prop="organization" label="工作单位" width="280"></el-table-column>
          <el-table-column prop="tel" label="联系电话" width="160"></el-table-column>
          <el-table-column prop="email" label="E-mail" width="200"></el-table-column>
          <el-table-column prop="addr" label="通讯地址" width="280"></el-table-column>
          <el-table-column prop="zipcode" label="邮政编码" width="100"></el-table-column>
        </el-table>
      </el-card>
      <!-- 主要参加者情况 -->
      <el-card>
        <div class="member">
          <span> 主要参加者情况</span>
        </div>
        <el-table :data="projectMember" style="width: 1021px" :header-cell-style="{ background: '#fafafa' }">
          <el-table-column prop="name" label="姓名" width="80"></el-table-column>
          <el-table-column prop="organization" label="单位" width="280"></el-table-column>
          <el-table-column prop="education" label="最后学历" width="80"></el-table-column>
          <el-table-column prop="major" label="所学专业" width="160"></el-table-column>
          <el-table-column prop="duty" label="技术职务" width="120"></el-table-column>
          <el-table-column prop="division" label="研究分工" width="200"></el-table-column>
        </el-table>
      </el-card>
      <!-- 预期成果形式 -->
      <el-card>
        <el-row class="el-row-detail">
          <el-col :span="8"><span> 预期成果形式：</span>
            <el-input :disabled="true" v-model="editForm.result_type"></el-input>
          </el-col>
          <el-col :span="8"><span> 字数：</span>
            <el-input :disabled="true" v-model="editForm.total_words"></el-input>
          </el-col>
          <el-col :span="8"><span> 预计完成时间：</span>
            <el-input :disabled="true" v-model="editForm.complete_time"></el-input>
          </el-col>
        </el-row>
      </el-card>
      <!-- 课题研究计划 -->
      <el-card>
        <div>课题研究计划</div>
        <quill-editor :disabled="true" v-model="editForm.content" :options="editorOption" class="editor"></quill-editor>
      </el-card>
      <!-- 预算 -->
      <el-card>
        <h3>课题预算</h3>
        <div class="div-budget">
          <div>
            <table>
              <tr>
                <td>序号</td>
                <td>预算科目名称</td>
                <td>预算金额（万元）</td>
                <td>测算依据（另附页说明）</td>
              </tr>
              <tr>
                <td>1</td>
                <td>经费总额</td>
                <td>
                  <el-input v-model="budget.f1"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s1"></el-input>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>一、直接费用</td>
                <td>
                  <el-input v-model="budget.f2"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s2"></el-input>
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>1.设备费</td>
                <td>
                  <el-input v-model="budget.f3"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s3"></el-input>
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>（1）购置设备费</td>
                <td>
                  <el-input v-model="budget.f4"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s4"></el-input>
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>（2）试制设备费</td>
                <td>
                  <el-input v-model="budget.f5"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s5"></el-input>
                </td>
              </tr>
              <tr>
                <td>6</td>
                <td>（3）设备改造与租赁费</td>
                <td>
                  <el-input v-model="budget.f6"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s6"></el-input>
                </td>
              </tr>
              <tr>
                <td>7</td>
                <td>2.材料费</td>
                <td>
                  <el-input v-model="budget.f7"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s7"></el-input>
                </td>
              </tr>
              <tr>
                <td>8</td>
                <td>3.测试化验加工费</td>
                <td>
                  <el-input v-model="budget.f8"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s8"></el-input>
                </td>
              </tr>
              <tr>
                <td>9</td>
                <td>4.差旅费</td>
                <td>
                  <el-input v-model="budget.f9"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s9"></el-input>
                </td>
              </tr>
              <tr>
                <td>10</td>
                <td>其中：市内交通费</td>
                <td>
                  <el-input v-model="budget.f10"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s10"></el-input>
                </td>
              </tr>
              <tr>
                <td>11</td>
                <td>5.会议费</td>
                <td>
                  <el-input v-model="budget.f11"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s11"></el-input>
                </td>
              </tr>
              <tr>
                <td>12</td>
                <td>6.出版/印刷/文献/信息传播/知识产权事务费</td>
                <td>
                  <el-input v-model="budget.f12"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s12"></el-input>
                </td>
              </tr>
              <tr>
                <td>13</td>
                <td>7.劳务费</td>
                <td>
                  <el-input v-model="budget.f13"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s13"></el-input>
                </td>
              </tr>
              <tr>
                <td>14</td>
                <td>8.专家咨询费</td>
                <td>
                  <el-input v-model="budget.f14"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s14"></el-input>
                </td>
              </tr>
              <tr>
                <td>15</td>
                <td>二、间接经费（不得超过课题经费总额的10%）</td>
                <td>
                  <el-input v-model="budget.f15"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s15"></el-input>
                </td>
              </tr>
              <tr>
                <td>16</td>
                <td>1.管理费用</td>
                <td>
                  <el-input v-model="budget.f16"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s16"></el-input>
                </td>
              </tr>
              <tr>
                <td>17</td>
                <td>2.其他具体说明</td>
                <td>
                  <el-input v-model="budget.f17"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s17"></el-input>
                </td>
              </tr>
            </table>
            <div style="margin-top: 20px;">
              <span style="font-size: 20px;">测算依据说明:</span>
            </div>
            <quill-editor v-model="budget.reason" :options="editorOption" class="editor"></quill-editor>
          </div>
        </div>
      </el-card>
      <!-- 审核 -->
      <el-card>
        <div>审核意见</div>
        <quill-editor v-model="auditInfo.info" :disabled="true" :options="editorOption" class="editor"></quill-editor>
      </el-card>
    </el-card>

    <!-- 11-26取消 申报书查看对话框，显示申报书图片 -->
    <!-- <el-dialog title="申报书详情" :visible.sync="infoDialogVisible" width="60%">
      <div v-show="projectInfoPngIsNull">请等待详情页面加载……</div>
      <div v-for="item in projectInfoPng" :key="item.id">
        <img :src="item.content" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="infoDialogHide()">确定</el-button>
      </div>
    </el-dialog> -->

    <!-- pdf查看 -->
    <el-dialog :visible.sync="pdfVisible" width="80%" :style="{ top: '-150px' }">
      <div class="onlineHelp cg-box">
        <div class="tools">
          <el-button type="mini" @click="zoomIn">放大</el-button>
          <el-button type="mini" @click="zoomOut">缩小</el-button>
        </div>
        <iframe :src="pdfSrc" width="100%" :height="iframeHeight" style="border:none;"></iframe>
      </div>
    </el-dialog>



    <!-- 图片查看 -->
    <el-dialog title="文件查看" :visible.sync="picVisible" width="50%">
      <el-image :src="picSrc"></el-image>
    </el-dialog>

    <!-- 视频查看 -->
    <el-dialog title="文件查看" :visible.sync="videoVisible" width="50%" @close='videoClose' fullscreen>
      <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions">
      </video-player>
    </el-dialog>

  </div>
</template>

<script>
//富文本
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import * as Quill from "quill";
import {
  quillEditor
} from "vue-quill-editor";
import {
  ImageDrop
} from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);

//下载
import fileDownload from "js-file-download";
// pdf预览
import pdf from 'vue-pdf'
// 视频
import {
  videoPlayer
} from 'vue-video-player'
import 'video.js/dist/video-js.css'
export default {
  components: {
    quillEditor,
    pdf,
    videoPlayer
  },
  data() {
    return {
      //pdf显示
      pdfSrc: '', // PDF 文件的 URL
      pdfVisible: false, // 控制 PDF 弹窗显示
      iframeHeight: '800px', // iframe 的高度，可以通过 zoomIn 和 zoomOut 来调整

      // 查看图片
      picSrc: '',
      picVisible: false,

      // 视频查看
      videoVisible: false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: '' // url地址
        }],
        poster: '', // 封面地址
        notSupportedMessage: '视频正在缓存，请稍候……', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          currentTimeDisplay: true, // 当前时间
          volumeControl: true, // 声音控制键
          progressControl: false, // 进度条
          playToggle: false, // 暂停-播放 按钮
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },

      // 20230425 新增课题类别、方向查询条件
      projectCategorys: [], //课题类别列表
      projectCategory: {}, //课题类别
      projectDirections: [], //课题方向

      // editContent: "",
      pid: "",
      userid: "",
      query: "", //查询条件
      projectInfo: [], //课题列表
      projectInfoShow: {}, //选中查看的
      // projectCategorys: [],
      // selectValue: "", //课题类型下拉框显示的值
      projectStatus: [],
      status: "",
      projectLeader: [], //主持人，返回的是列表
      leader: {}, //主持人，取列表第一项
      projectMember: [], //本项目参加人
      infoFormVisible: false,
      editForm: {}, //编辑申报书
      auditInfo: {},
      editLeaderVisible: false, //显示编辑主持人对话框

      fileList: [], //附件列表
      fileListSignAgreement: [], //保密协议及计划任务书
      fileListMiddleCheck: [], //中期检查
      fileListFinalCheck: [], //结题验收
      fileListTestData: [], //测试数据与分析报告

      infoDialogVisible: false, //对话框
      projectInfoPng: [], //课题信息图片
      projectInfoPngIsNull: true, //图片是否为空，显示“请等待详情页面加载……”
      budget: {},
      // qill-editor
      editorOption: {
        modules: {
          imageDrop: true, //图片拖拽
          imageResize: {
            //放大缩小
            displaySize: true,
          },
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
            ["blockquote", "code-block"], // 引用  代码块
            [{
              header: 1
            }, {
              header: 2,
            }], // 1、2 级标题
            [{
              list: "ordered",
            },
            {
              list: "bullet",
            },
            ], // 有序、无序列表
            [{
              script: "sub",
            },
            {
              script: "super",
            },
            ], // 上标/下标
            [{
              indent: "-1",
            },
            {
              indent: "+1",
            },
            ], // 缩进
            // [{'direction': 'rtl'}],                         // 文本方向
            [{
              size: ["small", false, "large", "huge"],
            },], // 字体大小
            [{
              header: [1, 2, 3, 4, 5, 6, false],
            },], // 标题
            [{
              color: [],
            },
            {
              background: [],
            },
            ], // 字体颜色、字体背景颜色
            [{
              font: [],
            },], // 字体种类
            [{
              align: [],
            },], // 对齐方式
            ["clean"], // 清除文本格式
            ["link", "image", "video"], // 链接、图片、视频
          ], //工具菜单栏配置
        },
        placeholder: "请在这里填写审核信息", //提示
        readyOnly: false, //是否只读
        theme: "snow", //主题 snow/bubble
      },
    };
  },

  created() {
    // this.getProjectCategorys();
    this.userid = localStorage.getItem("userid");
    this.getProjectInfoLite();
    this.getProjectStatus();

    this.getProjectCategorys()
  },
  // 释放 URL 对象，防止内存泄漏
  beforeClose() {
    URL.revokeObjectURL(this.pdfSrc);
    this.pdfSrc = ''; // 清空 PDF URL
  },
  watch: {
    projectInfoShow() {
      this.editForm = this.projectInfoShow;
      this.budget = this.editForm.budget
    },
  },
  methods: {
    //获取课题类别
    async getProjectCategorys() {
      const res1 = await this.axios.get(`/projectCategory/`)
      if (res1.status === 200) {
        this.projectCategorys = res1.data.results
      } else {
        this.$message.warning("获取类型错误")
      }
    },

    // 课题类别下拉框改变
    async changeCategory(event) {
      // 查找类别列表，定位类别
      this.projectCategory = this.projectCategorys.find(item => item.name == event)
      // console.log('e', this.projectCategory)
      if (this.projectCategory.direction == null || this.projectCategory.direction.data == null) {
        this.projectDirections = []
        return this.$message.warning(`课题方向为空，请先添加课题方向！`)
      }
      this.projectDirections = this.projectCategory.direction.data

      // 查询
      const res = await this.axios.get(`/projectInfoLite/?category=${event}&ordering=name`);
      if (res.status === 200) {
        this.projectInfo = res.data.results;
        // 增加字段
        this.projectInfoAddField()
      } else {
        this.$message.warning("错误");
      }

      this.infoFormVisible = false
    },

    // 课题方向下拉框改变
    async changeDirection(event) {
      console.log('category:', this.projectCategory)
      // 查询
      const res = await this.axios.get(`/projectInfoLite/?category=${this.projectCategory.name}&category_direction=${event}&ordering=name`);
      if (res.status === 200) {
        this.projectInfo = res.data.results;
        // 增加字段
        this.projectInfoAddField()
      } else {
        this.$message.warning("错误");
      }

      this.infoFormVisible = false
    },


    // 0609 获取课题信息,简单版，不需要content，速度问题
    // 20230425 新增类别、方向查询条件
    async getProjectInfoLite() {
      const res = await this.axios.get(`/projectInfoLite`);

      if (res.status === 200) {
        this.projectInfo = res.data.results;
        // 增加字段
        this.projectInfoAddField()
      } else {
        this.$message.warning("错误");
      }
    },

    // 20230516 projectInfo添加作者、单位、联系电话、邮箱
    async projectInfoAddField() {
      for (let i = 0; i < this.projectInfo.length; i++) {
        let res = await this.axios.get(`/user/?userid=${this.projectInfo[i].leader}`)
        if (res.status === 200) {
          // console.log('1', res.data.results[0])
          this.projectInfo[i].organization = res.data.results[0].organization
          this.projectInfo[i].tel = res.data.results[0].tel
          this.projectInfo[i].email = res.data.results[0].email
          // 经费
          this.projectInfo[i].budget = this.projectInfo[i].budget.f1
        }
      }
      this.$forceUpdate()
      // console.log(this.projectInfo)
    },

    // 获取审核信息
    async getAuditInfo(pid) {
      this.auditInfo.auditor = localStorage.getItem("userid");
      try {
        const res = await this.axios.get(`/auditInfo/?pid=${pid}`);
        if (res.status === 200) {
          if (res.data.results[0]) {
            this.auditInfo = res.data.results[0];
          }
        }
      } catch (err) {
        // console.log(err)
      }
    },

    // // 获取课题类别方向
    // async getProjectCategorys() {
    //   const res = await this.axios.get(`/projectCategorySon/`);
    //   if (res.status === 200) {
    //     this.projectCategorys = res.data.results;
    //   } else {
    //     this.$message.warning("错误");
    //   }
    // },

    // 获取课题状态
    async getProjectStatus() {
      const res = await this.axios.get(`/projectStatus/`);
      if (res.status === 200) {
        this.projectStatus = res.data;
      } else {
        this.$message.warning("错误");
      }
    },

    // 获取课题信息
    //0609 改为获取某个课题信息
    async getProjectInfo(pid) {
      const res = await this.axios.get(`/projectInfo/?pid=${pid}`);
      if (res.status === 200) {
        // console.log('info', res.data.results)
        this.projectInfoShow = res.data.results[0];
      } else {
        this.$message.warning("错误");
      }
    },

    // 查询课题信息
    async queryProjectInfo() {
      // const res = await this.axios.get(`/projectInfoLite/?search=${this.query}`)
      const res = await this.axios.get(
        `/projectInfoLite/?search=${this.query}`
      );
      if (res.status === 200) {
        this.projectInfo = res.data.results;
      } else {
        this.$message.warning("错误");
      }
    },

    // 获取附件列表
    async getFileList(pid) {
      this.fileList = []
      this.fileListSignAgreement = []
      this.fileListMiddleCheck = []

      const res = await this.axios.get(`/fileList/?pid=${pid}`);
      if (res.status === 200) {
        this.fileList = res.data.results;
      } else {
        this.$message.warning("获取文件列表错误");
      }
      // 保密协议、计划任务书
      const resAgreement = await this.axios.get(`/fileList/?pid=${pid}` + '/保密协议及计划任务书')
      if (resAgreement.status === 200) {
        let files = resAgreement.data.results
        this.fileListSignAgreement = []
        for (let i = 0; i < files.length; i++) {
          // 如果名称包含“计划任务书”，则添加到fileListSignAgreement
          // if (files[i].name.includes("计划任务书")) {
          //   this.fileListSignAgreement.push(files[i])
          // }
          this.fileListSignAgreement.push(files[i])
        }
      } else {
        this.$message.warning("获取文件列表错误")
      }
      // 测试数据与分析报告
      const resTest = await this.axios.get(`/fileList/?pid=${pid}` + '/测试数据与分析报告')
      if (resTest.status === 200) {
        this.fileListTestData = resTest.data.results
      } else {
        this.$message.warning("获取文件列表错误")
      }
      // 中期检查
      const resMiddle = await this.axios.get(`/fileList/?pid=${pid}` + '/中期检查阶段成果报告')
      if (resMiddle.status === 200) {
        this.fileListMiddleCheck = resMiddle.data.results
      } else {
        this.$message.warning("获取文件列表错误")
      }
      // 结题验收
      const resFinal = await this.axios.get(`/fileList/?pid=${pid}` + '/结题材料')
      if (resFinal.status === 200) {
        this.fileListFinalCheck = resFinal.data.results
      } else {
        this.$message.warning("获取文件列表错误")
      }
    },

    // 查询主持人信息
    async getProjectLeader(userid) {
      const res = await this.axios.get(`/user/?userid=${userid}`);
      if (res.status === 200) {
        this.projectLeader = res.data.results;
        this.leader = this.projectLeader[0];
      } else {
        this.$message.warning("错误");
      }
    },

    // 获取username
    async getUserName(userid) {
      const res = await this.axios.get(`/user/?userid=${userid}`);
      if (res.status === 200) {
        return this.projectLeader[0].username;
      } else {
        this.$message.warning("错误");
      }
    },

    // 查询参加者
    async getProjectMember(id) {
      const res = await this.axios.get(`/projectMember/?pid=${id}`);
      if (res.status === 200) {
        this.projectMember = res.data.results;
      } else {
        this.$message.warning("错误");
      }
    },

    //获取状态名称
    statusName(id) {
      name = "";
      this.projectStatus.forEach((s) => {
        if (s.s_id == id) {
          name = s.status;
        }
      });
      return name;
    },

    // // 获取类别名称
    // categoryName(id) {
    //   const item = this.projectCategorys.find((item) => item.id == id);
    //   return item ? item.name : null;
    // },

    // 获取课题图片，供管理员查看
    async getProjectInfoPng(pid) {
      const res = await this.axios.get("/projectInfoPng/?pid=" + pid);
      this.projectInfoPng = res.data.results;
      // console.log('png', this.projectInfoPng)
    },

    // 显示查看申报书卡片
    showInfoForm(item) {
      this.infoFormVisible = true;
      this.pid = item.pid; //查看图片、下载原文件用
      this.getProjectInfo(item.pid);
      this.editForm = this.projectInfoShow;
      // console.log('editForm', this.editForm)

      // this.selectValue = this.categoryName(this.editForm.category); //讲id转换成文字
      this.getProjectMember(item.pid);
      this.getFileList(item.pid);
      this.auditInfo = {};
      this.getAuditInfo(item.pid);
      this.getProjectLeader(item.leader);

      // 课题信息对话框
      // this.infoDialogVisible = true
      this.projectInfoPng = [];
      this.getProjectInfoPng(item.pid);

      setTimeout(() => {
        document.getElementById("id-el-card-info").scrollIntoView({
          behavior: "smooth",
        });
      }, 500);
    },

    // 按钮 查看图片
    ButtonShowPng() {
      this.infoDialogVisible = true;
    },
    ButtonDownOriginFile() {
      let name = "课题申请书" + this.pid + ".pdf";
      let path = "./toPdf/pdf_temp/" + name;
      let item = {
        path: path,
        name: name,
      };
      this.downloadFile(item);
    },

    // 隐藏课题对话框
    infoDialogHide() {
      this.infoDialogVisible = false;
    },

    // 下载文件
    downloadFile(item) {
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`;
      let params = {
        path: item.path,
        name: item.name,
      };
      this.axios
        .post(url, params, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          fileDownload(res.data, item.name);
        });
    },
    // 删除文件
    async deleteFile(item) {
      let res = await this.axios.delete("/fileList/" + item.id + "/");
      if (res.status === 204) {
        this.getFileList(item.pid);
      }
      let data = {
        path: item.path,
      };
      let resDelete = await this.axios.post("/deleteFile/", data);
      // console.log(resDelete)
    },


    // 判断文件类型，调用不同的查看方法
    getFileCode(item) {
      let name = item.name.slice(-3)
      if (name == 'jpg' || name == 'png' || name == 'bpm') {
        this.getPicCode(item)
      } else if (name == 'pdf') {
        this.getPdfCode(item)
      } else if (name == 'mp4') {
        this.getVideoCode(item)
      }
    },


    // pdf预览
    // 获取 PDF 文件
    getPdfCode(item) {
      this.pdfVisible = true;  // 显示弹窗
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`;
      let params = {
        path: item.path,
        name: item.name
      };

      this.axios({
        method: 'post',
        url: url,
        data: params,
        responseType: 'blob' // 设置响应的数据类型为 Blob
      }).then(response => {
        // 检查是否为 PDF 文件
        const file = response.data;
        const blob = new Blob([file], { type: 'application/pdf' }); // 确保 MIME 类型是 PDF
        this.pdfSrc = URL.createObjectURL(blob); // 创建可供 iframe 使用的 URL
      }).catch(error => {
        console.error("加载 PDF 文件失败:", error);
      });
    },

    // 将 Blob 转换为 URL
    createPdfObjectURL(file) {
      return URL.createObjectURL(file); // 使用 URL.createObjectURL 创建可访问的文件 URL
    },
    // 放大 PDF
    zoomIn() {
      let currentHeight = parseInt(this.iframeHeight);
      this.iframeHeight = `${currentHeight + 100}px`; // 每次放大100px
    },
    // 缩小 PDF
    zoomOut() {
      let currentHeight = parseInt(this.iframeHeight);
      this.iframeHeight = `${Math.max(currentHeight - 100, 300)}px`; // 最小缩小到300px
    },

    // 视频查看
    getVideoCode(item) {
      this.videoVisible = true
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`
      console.log(url)
      let params = {
        path: item.path,
        name: item.name
      }
      this.axios({
        method: 'post',
        url: url,
        data: params,
        headers: {
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
        responseType: 'blob' //设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
      }).then(response => {
        this.playerOptions.sources[0].src = this.getObjectURL(response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 关闭窗口，停止视频
    videoClose() {
      this.playerOptions.sources[0].src = ''
    },

    // 图片查看
    getPicCode(item) {
      this.picVisible = true
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`
      let params = {
        path: item.path,
        name: item.name
      }
      this.axios({
        method: 'post',
        url: url,
        data: params,
        headers: {
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
        responseType: 'blob' //设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
      }).then(response => {
        this.picSrc = this.getObjectURL(response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 20230517 生成excel
    async projectInfoViewToExcel() {
      let infoTemp = []
      for (let i = 0; i < this.projectInfo.length; i++) {
        if (this.projectInfo[i].status == 4) {
          infoTemp.push(this.projectInfo[i])
        }
      }
      // 使用loading加载，客户等待
      const loading = this.$loading({
        lock: true, //lock的修改符--默认是false
        text: "Loading", //显示在加载图标下方的加载文案
        spinner: "el-icon-loading", //自定义加载图标类名
        background: "rgba(0, 0, 0, 0.7)", //遮罩层颜色
        target: document.querySelector("#table") //loadin覆盖的dom元素节点
      });

      let res = await this.axios.post("/projectInfoViewToExcel/", infoTemp)
      let fileName = {
        path: "/toExcel/申报书统计.xlsx",
        name: "申报书统计.xlsx"
      };
      //成功回调函数停止加载
      loading.close();
      if (res.status == 200) {
        this.downloadFile(fileName);
      }
    }
  },
};

</script>

<style lang="less">
.el-card {
  margin-top: 15px;
}

.header-edit {
  font-size: 18px;
  text-align: left;
  margin-bottom: 10px;
}

.el-col-user-add {
  display: flex;
}

.user-search {
  width: 420px;
  margin-right: 10px;
}

.el-col-addForm {
  display: flex;
  margin-bottom: 10px;

  span {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }

  .el-input {
    width: 400px;
  }
}

.el-card-leader {
  .div-leader {
    font-size: 16px;
    margin-bottom: 15px;
  }
}

.member {
  font-size: 16px;
  margin-bottom: 15px;
}

.el-row-detail {
  width: 1020px;

  .el-col {
    display: flex;

    span {
      display: flex;
      align-items: center;
      margin-left: 10px;
    }

    .el-input {
      width: 200px;
    }
  }
}

.editor {
  margin-top: 15px;
}

.ql-editor {
  min-height: 200px;
}

.div-upload {
  width: 500px;
  padding-top: 10px;
}

.div-add {
  margin-top: 20px;
  display: flex;
  justify-content: end;
}

.div-file {
  margin-top: 15px;
}

// 预算
.div-budget {
  display: flex;
  justify-content: center;

  table {
    border-top: 1px solid #000;
    border-left: 1px solid #000;
    border-spacing: 0;
    text-align: center;
    line-height: 40px;
  }

  td {
    padding-left: 10px;
    padding-right: 10px;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
  }

  td:nth-child(2) {
    text-align: left;
  }

  .editor {
    width: 730px;
  }

  .div-but {
    margin-top: 20px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/project/ProjectView.vue